import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const complianceDashboardPage = PageBlueprint.make({
  params: {
    path: '/compliance',
    noHeader: true,
    loader: () =>
      import('./components/ComplianceDashboardPage').then(m => (
        <PageErrorBoundary title="The compliance dashboard">
          <m.ComplianceDashboardPage />
        </PageErrorBoundary>
      )),
  },
});

const securityDashboardPage = PageBlueprint.make({
  name: 'security',
  params: {
    path: '/security',
    noHeader: true,
    loader: () =>
      import('./components/SecurityDashboardPage').then(m => (
        <PageErrorBoundary title="The security dashboard">
          <m.SecurityDashboardPage />
        </PageErrorBoundary>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'vivicta-compliance-dashboard',
  extensions: [complianceDashboardPage, securityDashboardPage],
});
